export class WrittenNumberOptions {
    private _languages = ['es', 'gl']
    private _noAnd = false
    private _alternativeBase = false
    private _lang: string

    constructor (lang: string) {
      if (this._languages.includes(lang)) {
        this._lang = lang
      } else { this._lang = 'gl' }
    }

    noAnd (): boolean {
      return this._noAnd
    }

    alternativeBase (): boolean {
      return this._alternativeBase
    }

    lang (): string {
      return this._lang
    }
}
